"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef } from "react";
import { useRouter } from "next/navigation";
import { BrainView } from "../BrainMobile";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveTabsLeaderboard from "../my-stream/MyStreamWaveTabsLeaderboard";
import { useLayout } from "../my-stream/layout/LayoutContext";
import { useWave } from "@/hooks/useWave";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import { useUnreadIndicator } from "@/hooks/useUnreadIndicator";
import { useUnreadNotifications } from "@/hooks/useUnreadNotifications";
import { useAuth } from "@/components/auth/Auth";
import { getWaveHomeRoute } from "../../../helpers/navigation.helpers";
interface BrainMobileTabsProps {
  readonly activeView: BrainView;
  readonly onViewChange: (view: BrainView) => void;
  readonly wave?: ApiWave | undefined;
  readonly waveActive: boolean;
  readonly showWavesTab: boolean;
  readonly showStreamBack: boolean;
  readonly isApp?: boolean | undefined;
}
const BrainMobileTabs: React.FC<BrainMobileTabsProps> = t0 => {
  const $ = _c(83);
  const {
    activeView,
    onViewChange,
    wave,
    waveActive,
    showWavesTab,
    showStreamBack,
    isApp
  } = t0;
  const router = useRouter();
  const {
    registerRef
  } = useLayout();
  const {
    connectedProfile
  } = useAuth();
  const mobileTabsRef = useRef(null);
  let t1;
  if ($[0] !== registerRef) {
    t1 = element => {
      mobileTabsRef.current = element;
      registerRef("mobileTabs", element);
    };
    $[0] = registerRef;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setMobileTabsRef = t1;
  const {
    isMemesWave,
    isCurationWave,
    isRankWave
  } = useWave(wave);
  const t2 = connectedProfile?.handle ?? null;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      type: "messages",
      handle: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    hasUnread: hasUnreadMessages
  } = useUnreadIndicator(t3);
  const {
    haveUnreadNotifications
  } = useUnreadNotifications(connectedProfile?.handle ?? null);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      [BrainView.DEFAULT]: null,
      [BrainView.ABOUT]: null,
      [BrainView.LEADERBOARD]: null,
      [BrainView.SALES]: null,
      [BrainView.WINNERS]: null,
      [BrainView.OUTCOME]: null,
      [BrainView.MY_VOTES]: null,
      [BrainView.FAQ]: null,
      [BrainView.WAVES]: null,
      [BrainView.MESSAGES]: null,
      [BrainView.NOTIFICATIONS]: null
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const tabRefs = useRef(t4);
  let t5;
  let t6;
  if ($[5] !== activeView) {
    t5 = () => {
      const activeTabEl = tabRefs.current[activeView];
      if (activeTabEl) {
        activeTabEl.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });
      }
    };
    t6 = [activeView];
    $[5] = activeView;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  React.useEffect(t5, t6);
  const aboutButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1  tw-rounded-md ${activeView === BrainView.ABOUT ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const aboutButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.ABOUT ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const outcomeButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1  tw-rounded-md ${activeView === BrainView.OUTCOME ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const otucomeButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.OUTCOME ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const myVotesButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1  tw-rounded-md ${activeView === BrainView.MY_VOTES ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const myVotesButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.MY_VOTES ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const salesButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1 tw-rounded-md ${activeView === BrainView.SALES ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const salesButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.SALES ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const chatButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1  tw-rounded-md ${activeView === BrainView.DEFAULT ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const chatButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.DEFAULT ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const wavesButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1  tw-rounded-md ${activeView === BrainView.WAVES ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const wavesButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.WAVES ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const messagesButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1 tw-rounded-md ${activeView === BrainView.MESSAGES ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const messagesButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap tw-relative ${activeView === BrainView.MESSAGES ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const notificationsButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5 tw-gap-1 tw-flex-1 tw-rounded-md ${activeView === BrainView.NOTIFICATIONS ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const notificationsButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap tw-relative ${activeView === BrainView.NOTIFICATIONS ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  let t7;
  if ($[8] !== onViewChange) {
    t7 = () => {
      onViewChange(BrainView.DEFAULT);
    };
    $[8] = onViewChange;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const onChatClick = t7;
  let t8;
  if ($[10] !== onViewChange) {
    t8 = () => {
      onViewChange(BrainView.NOTIFICATIONS);
    };
    $[10] = onViewChange;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const onNotificationsClick = t8;
  let t9;
  if ($[12] !== isCurationWave || $[13] !== onViewChange || $[14] !== salesButtonClasses || $[15] !== salesButtonTextClasses || $[16] !== wave || $[17] !== waveActive) {
    t9 = waveActive && wave && isCurationWave ? <button ref={el => {
      tabRefs.current[BrainView.SALES] = el;
    }} onClick={() => onViewChange(BrainView.SALES)} className={salesButtonClasses}><span className={salesButtonTextClasses}>Sales</span></button> : null;
    $[12] = isCurationWave;
    $[13] = onViewChange;
    $[14] = salesButtonClasses;
    $[15] = salesButtonTextClasses;
    $[16] = wave;
    $[17] = waveActive;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const salesTabButton = t9;
  let t10;
  if ($[19] !== isApp || $[20] !== onViewChange || $[21] !== router || $[22] !== showStreamBack || $[23] !== waveActive) {
    t10 = waveActive && showStreamBack && !isApp && <><button onClick={() => {
        router.push(getWaveHomeRoute({
          isDirectMessage: false,
          isApp: !!isApp
        }));
        onViewChange(BrainView.DEFAULT);
      }} className="tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-2 tw-py-1.5  tw-gap-1 tw-flex-1 tw-rounded-md tw-bg-iron-950"><ArrowLeftIcon className="tw-size-4 tw-text-iron-400" /><span className="tw-whitespace-nowrap tw-text-xs tw-font-semibold tw-text-iron-400 sm:tw-text-sm">My Stream</span></button><div className="tw-mx-1 tw-h-4 tw-w-px tw-flex-shrink-0 tw-bg-iron-700" /></>;
    $[19] = isApp;
    $[20] = onViewChange;
    $[21] = router;
    $[22] = showStreamBack;
    $[23] = waveActive;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== onViewChange || $[26] !== showWavesTab || $[27] !== waveActive || $[28] !== wavesButtonClasses || $[29] !== wavesButtonTextClasses) {
    t11 = !waveActive && showWavesTab && <button ref={el_0 => {
      tabRefs.current[BrainView.WAVES] = el_0;
    }} onClick={() => onViewChange(BrainView.WAVES)} className={wavesButtonClasses}><span className={wavesButtonTextClasses}>Waves</span></button>;
    $[25] = onViewChange;
    $[26] = showWavesTab;
    $[27] = waveActive;
    $[28] = wavesButtonClasses;
    $[29] = wavesButtonTextClasses;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== hasUnreadMessages || $[32] !== isApp || $[33] !== messagesButtonClasses || $[34] !== messagesButtonTextClasses || $[35] !== onViewChange || $[36] !== waveActive) {
    t12 = !isApp && !waveActive && <button ref={el_1 => {
      tabRefs.current[BrainView.MESSAGES] = el_1;
    }} onClick={() => onViewChange(BrainView.MESSAGES)} className={messagesButtonClasses}><span className={messagesButtonTextClasses}><span>Messages</span>{hasUnreadMessages && <div className="tw-absolute -tw-right-3 tw-top-0 tw-h-2 tw-w-2 tw-rounded-full tw-bg-red" />}</span></button>;
    $[31] = hasUnreadMessages;
    $[32] = isApp;
    $[33] = messagesButtonClasses;
    $[34] = messagesButtonTextClasses;
    $[35] = onViewChange;
    $[36] = waveActive;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = el_2 => {
      tabRefs.current[BrainView.DEFAULT] = el_2;
    };
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  const t14 = waveActive ? "Chat" : "My Stream";
  let t15;
  if ($[39] !== chatButtonTextClasses || $[40] !== t14) {
    t15 = <span className={chatButtonTextClasses}>{t14}</span>;
    $[39] = chatButtonTextClasses;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== chatButtonClasses || $[43] !== onChatClick || $[44] !== t15) {
    t16 = <button ref={t13} onClick={onChatClick} className={chatButtonClasses}>{t15}</button>;
    $[42] = chatButtonClasses;
    $[43] = onChatClick;
    $[44] = t15;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== aboutButtonClasses || $[47] !== aboutButtonTextClasses || $[48] !== onViewChange || $[49] !== waveActive) {
    t17 = waveActive && <button ref={el_3 => {
      tabRefs.current[BrainView.ABOUT] = el_3;
    }} onClick={() => onViewChange(BrainView.ABOUT)} className={aboutButtonClasses}><span className={aboutButtonTextClasses}>About</span></button>;
    $[46] = aboutButtonClasses;
    $[47] = aboutButtonTextClasses;
    $[48] = onViewChange;
    $[49] = waveActive;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  const t18 = !isRankWave && salesTabButton;
  let t19;
  if ($[51] !== activeView || $[52] !== isCurationWave || $[53] !== isMemesWave || $[54] !== isRankWave || $[55] !== myVotesButtonClasses || $[56] !== myVotesButtonTextClasses || $[57] !== onViewChange || $[58] !== otucomeButtonTextClasses || $[59] !== outcomeButtonClasses || $[60] !== salesTabButton || $[61] !== wave || $[62] !== waveActive) {
    t19 = waveActive && wave && isRankWave && <><MyStreamWaveTabsLeaderboard wave={wave} activeView={activeView} onViewChange={onViewChange} registerTabRef={(view, el_4) => {
        tabRefs.current[view] = el_4;
      }} renderAfterLeaderboard={salesTabButton} />{(isMemesWave || isCurationWave) && <><button ref={el_5 => {
          tabRefs.current[BrainView.MY_VOTES] = el_5;
        }} onClick={() => onViewChange(BrainView.MY_VOTES)} className={myVotesButtonClasses}><span className={myVotesButtonTextClasses}>My Votes</span></button></>}<button ref={el_6 => {
        tabRefs.current[BrainView.OUTCOME] = el_6;
      }} onClick={() => onViewChange(BrainView.OUTCOME)} className={outcomeButtonClasses}><span className={otucomeButtonTextClasses}>Outcome</span></button>{isMemesWave && <button ref={el_7 => {
        tabRefs.current[BrainView.FAQ] = el_7;
      }} onClick={() => onViewChange(BrainView.FAQ)} className={`tw-flex tw-flex-1 tw-items-center tw-justify-center tw-gap-1 tw-rounded-md tw-border-none tw-px-2 tw-py-1.5 tw-no-underline ${activeView === BrainView.FAQ ? "tw-bg-iron-800" : "tw-bg-iron-950"}`}><span className={`tw-whitespace-nowrap tw-text-xs tw-font-semibold sm:tw-text-sm ${activeView === BrainView.FAQ ? "tw-text-iron-300" : "tw-text-iron-400"}`}>FAQ</span></button>}</>;
    $[51] = activeView;
    $[52] = isCurationWave;
    $[53] = isMemesWave;
    $[54] = isRankWave;
    $[55] = myVotesButtonClasses;
    $[56] = myVotesButtonTextClasses;
    $[57] = onViewChange;
    $[58] = otucomeButtonTextClasses;
    $[59] = outcomeButtonClasses;
    $[60] = salesTabButton;
    $[61] = wave;
    $[62] = waveActive;
    $[63] = t19;
  } else {
    t19 = $[63];
  }
  let t20;
  if ($[64] !== haveUnreadNotifications || $[65] !== isApp || $[66] !== notificationsButtonClasses || $[67] !== notificationsButtonTextClasses || $[68] !== onNotificationsClick || $[69] !== waveActive) {
    t20 = !isApp && !waveActive && <button ref={el_8 => {
      tabRefs.current[BrainView.NOTIFICATIONS] = el_8;
    }} onClick={onNotificationsClick} className={notificationsButtonClasses}><span className={notificationsButtonTextClasses}>Notifications{haveUnreadNotifications && <div className="tw-absolute -tw-right-1 -tw-top-1 tw-h-2 tw-w-2 tw-rounded-full tw-bg-red" />}</span></button>;
    $[64] = haveUnreadNotifications;
    $[65] = isApp;
    $[66] = notificationsButtonClasses;
    $[67] = notificationsButtonTextClasses;
    $[68] = onNotificationsClick;
    $[69] = waveActive;
    $[70] = t20;
  } else {
    t20 = $[70];
  }
  let t21;
  if ($[71] !== t10 || $[72] !== t11 || $[73] !== t12 || $[74] !== t16 || $[75] !== t17 || $[76] !== t18 || $[77] !== t19 || $[78] !== t20) {
    t21 = <div className="tw-flex tw-w-full tw-items-center tw-justify-start tw-gap-1 tw-overflow-x-auto tw-overflow-y-hidden tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-950 tw-p-1 tw-py-1 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 desktop-hover:hover:tw-scrollbar-thumb-iron-300">{t10}{t11}{t12}{t16}{t17}{t18}{t19}{t20}</div>;
    $[71] = t10;
    $[72] = t11;
    $[73] = t12;
    $[74] = t16;
    $[75] = t17;
    $[76] = t18;
    $[77] = t19;
    $[78] = t20;
    $[79] = t21;
  } else {
    t21 = $[79];
  }
  let t22;
  if ($[80] !== setMobileTabsRef || $[81] !== t21) {
    t22 = <div ref={setMobileTabsRef} className="tw-overflow-x-auto tw-px-2 tw-py-2 sm:tw-px-4 md:tw-px-6">{t21}</div>;
    $[80] = setMobileTabsRef;
    $[81] = t21;
    $[82] = t22;
  } else {
    t22 = $[82];
  }
  return t22;
};
export default BrainMobileTabs;